import React, { useState } from "react";
import "./Close_modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { closeTrades } from "../../../../utils/apis/buy_and_sell/buy_and_sell";
import Successfull_Modal from "../successfull_modal/Successfull_Modal";
import Deposit_Lottie from "../../../animation/deposit_lottie/Deposit_Lottie";
import { useForm } from "react-hook-form";

const Close_modal = (props) => {
  const [showModal, setShowModal] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();
  const submitClose = async () => {
    try {
      const payload = {
        quantity: Number(props.closeQuantity),
        amount: props?.latestAmount,
      };
      const res = await closeTrades(props.closeTradeId, {
        latest_amount: props?.latestAmount,
        quantity: Number(props.closeQuantity),
      });

      if (res?.success) {
        setShowModal(true);

        props.getGraphData();

        setTimeout(() => {
          setShowModal(false);
        }, 3000);
        setTimeout(() => {
          props.onHide(true);
          props.onClose(true);
        }, 100);
      } else {
        setError("amount", { message: res?.message || "Transaction failed" });
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("amount", { message: "An error occurred. Please try again." });
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="close_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Close Trade
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p className="msgg">Want To Close This Trade</p>
          </div>
        </Modal.Body>
        <div className="text-center">
          <Button className="confirmbtn" onClick={submitClose}>
            Confirm
          </Button>
        </div>
      </Modal>

      <Successfull_Modal
        message={`Trade Successful! Close`}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        lottie={<Deposit_Lottie />}
      />
    </>
  );
};

export default Close_modal;
